// import { Artwork } from '../store/artworkStore';
// import { CurrencyCode, useCurrencyStore } from '../store/currencyStore';


// export const getArtworkPrice = (artwork: Artwork, selectedCurrency: CurrencyCode): { price: number; currency: string } => {
  
//   if (artwork.prices && artwork.prices[selectedCurrency] !== undefined && artwork.prices[selectedCurrency]! > 0) {
    
//     return {
//       price: artwork.prices[selectedCurrency]!,
//       currency: selectedCurrency,
//     };
//   }
  
 
//   if (artwork.prices && Object.keys(artwork.prices).length > 0) {
    
//     const availableCurrencies = Object.keys(artwork.prices) as CurrencyCode[];
//     if (availableCurrencies.length > 0) {
     
//       const fallbackCurrency = availableCurrencies[0] as CurrencyCode;
//       const fallbackPrice = artwork.prices[fallbackCurrency];
//       if (fallbackPrice && fallbackPrice > 0) {
        
//         return {
//           price: fallbackPrice,
//           currency: selectedCurrency,
//         };
//       }
//     }
//   }
  
 
//   return {
//     price: artwork.price || 0,
//     currency: selectedCurrency,
//   };
// };


// export const formatPrice = (price: number, currency: CurrencyCode | string, hidePrices: boolean = false): string => {
//   if (hidePrices) return '';
//   if (!price || price === 0) return '';

//   try {
//     const code = (currency || 'EUR').toUpperCase();

   
//     const formatted = new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: code,
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     }).format(price);

   
//     return formatted.replace(/(\p{Sc})(\d)/u, '$1 $2');
//   } catch {
    
//     return `${currency.toUpperCase()} ${Math.round(price).toLocaleString('en-US')}`;
//   }
// };


// export const formatArtworkPrice = (artwork: Artwork, hidePrices: boolean = false, selectedCurrency?: CurrencyCode): string => {
 
//   const currency = selectedCurrency || useCurrencyStore.getState().selectedCurrency;
//   const { price, currency: displayCurrency } = getArtworkPrice(artwork, currency);
  
  
  
//   return formatPrice(price, displayCurrency, hidePrices);
// };


import { Artwork } from '../store/artworkStore';
import { CurrencyCode, useCurrencyStore } from '../store/currencyStore';

/**
 * Normalize artwork fields so PriceRef & CurrencyRef always exist,
 * even if Odoo sent fields as "price" and "currencyRef".
 */
export const normalizeArtworkFields = (artwork: any) => {
  // ⭐ Normalize PriceRef
  artwork.PriceRef = 
      artwork.PriceRef ??
      artwork.price ??   // Odoo sends this
      0;

  // ⭐ Normalize CurrencyRef
  artwork.CurrencyRef = 
      artwork.CurrencyRef ??
      artwork.currencyRef ??  // Odoo sends this
      artwork.currency ??     // fallback
      "EUR";

  return artwork;
};


/**
 * CLIENT REQUIREMENT:
 * MultiDevice → ALWAYS use PriceRef + CurrencyRef (no EUR fallback)
 */
export const getArtworkPrice = (
  rawArtwork: any,
  selectedCurrency: CurrencyCode
): { price: number; currency: string } => {

  // ⭐ Normalize so fields always exist
  const artwork = normalizeArtworkFields(rawArtwork);

  // ⭐ Rule 1: MultiDevice → use PriceRef + CurrencyRef ONLY
  if (selectedCurrency === "MultiDevices") {
    return {
      price: artwork.PriceRef ?? 0,
      currency: artwork.CurrencyRef || "EUR",
    };
  }

  // ⭐ Rule 2: Normal currency lookup (CHF, USD, EUR, etc.)
  if (
    artwork.prices &&
    artwork.prices[selectedCurrency] !== undefined &&
    artwork.prices[selectedCurrency] > 0
  ) {
    return {
      price: artwork.prices[selectedCurrency],
      currency: selectedCurrency,
    };
  }

  // ⭐ Rule 3: Fallback → first available valid currency price
  if (artwork.prices && Object.keys(artwork.prices).length > 0) {
    const availableCurrencies = Object.keys(artwork.prices) as CurrencyCode[];
    for (const currency of availableCurrencies) {
      const p = artwork.prices[currency];
      if (p && p > 0) {
        return {
          price: p,
          currency,
        };
      }
    }
  }

  // ⭐ Rule 4: Legacy fallback price
  return {
    price: artwork.price || 0,
    currency: selectedCurrency,
  };
};


/**
 * Format price into readable currency string.
 */
export const formatPrice = (
  price: number,
  currency: CurrencyCode | string,
  hidePrices: boolean = false
): string => {

  if (hidePrices) return '';
  if (!price || price === 0) return '';

  try {
    const code = (currency || 'EUR').toUpperCase();

    // const formatted = new Intl.NumberFormat('en-US', {
    //   style: 'currency',
    //   currency: code,
    //   minimumFractionDigits: 0,
    //   maximumFractionDigits: 0,
    // }).format(price);
      const formattedNumber = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);

return `${currency} ${formattedNumber}`;
    // add space after currency symbol
    // return formatted.replace(/(\p{Sc})(\d)/u, '$1 $2');

  } catch {
    return `${currency.toUpperCase()} ${Math.round(price).toLocaleString('en-US')}`;
  }
};



export const formatPriceForPDF = (
  price: number,
  currency: CurrencyCode | string,
  hidePrices: boolean = false
): string => {
  // Keep PDF formatting same as listing: use currency code, not symbol.
  return formatPrice(price, currency, hidePrices);
};



/**
 * Public function used inside UI.
 */
export const formatArtworkPrice = (
  artwork: Artwork,
  hidePrices: boolean = false,
  selectedCurrency?: CurrencyCode
): string => {

  const currency = selectedCurrency || useCurrencyStore.getState().selectedCurrency;

  const { price, currency: displayCurrency } = getArtworkPrice(artwork, currency);

  return formatPrice(price, displayCurrency, hidePrices);
};

/** Same resolution as ArtworkPDF.tsx `getGroupKey` for `price` (getArtworkPrice + formatPrice). */
export const formatArtworkPriceForDisplay = (
  artwork: any,
  selectedCurrency: CurrencyCode
): string => {
  const { price, currency: displayCurrency } = getArtworkPrice(artwork, selectedCurrency);
  return formatPrice(price, displayCurrency);
};

